import { SearchFilterData } from "../../types/interface"


// Filters
// export const cxTopicSignal = 'cx_topics'
export const cxTopicSignal = 'labelling_analysis.x_ssense_labels_called_out_v1.x_ssense_conversationcxtopic_v1'

export const filters: Array<SearchFilterData> = [
    {
        id: 1,
        title: 'Conversation Type',
        slug: 'communication_mode',
        parameters: [
            {
                id: 1,
                title: 'Email',
                slug: 'email',
                isFacet: false
            },
            {
                id: 2,
                title: 'Chat',
                slug: 'chat',
                isFacet: false,
                disabled: true,
            },
            {
                id: 3,
                title: 'Audio Call',
                slug: 'audio',
                isFacet: false,
                disabled: true,
            },
            {
                id: 4,
                title: 'Video Pitch',
                disabled: true,
                isFacet: false
            },
        ]
    },
    {
        id: 2,
        title: 'Flags',
        slug: 'flags',
        parameters: [
            {
                id: 1,
                title: 'Customer Escalation',
                slug: 'customer_escalation',
            },
            {
                id: 2,
                title: 'Duration > AHT',
                slug: 'duration_gt_aht',
            },
            {
                id: 3,
                title: 'Hold Time / Wait Time',
                slug: 'hold_or_wait_time',
            },
            {
                id: 4,
                title: 'Agent Skipped Intro',
                slug: 'agent_skipped_intro',
            },
            {
                id: 5,
                title: 'Agent Skipped Salutation',
                slug: 'agent_skipped_salutation',
            },
            {
                id: 6,
                title: 'Agent Fast Paced',
                slug: 'agent_fast_paced',
            },
            {
                id: 7,
                title: 'Agent Profanity',
                bucketSlug: 'agent_profanity',
                slug: 'agent_profanity',
            },
            {
                id: 8,
                title: 'Customer Profanity',
                bucketSlug: 'customer_profanity',
                slug: 'customer_profanity',
            },
            {
                id: 9,
                title: 'Customer Declining Sentiment',
                bucketSlug: 'customer_declining_sentiment',
                slug: 'customer_declining_sentiment',
            },
            {
                id: 10,
                title: 'Agent Declining Sentiment',
                bucketSlug: 'agent_declining_sentiment',
                slug: 'agent_declining_sentiment',
            }
        ]
    },
    {
        id: 3,
        title: 'CX Topics',
        slug: 'cx_topics',
        signal: cxTopicSignal, 
        parameters: []
    },
    {
        id: 4,
        title: 'Customer Tonality',
        slug: 'customer_tonality',
        parameters: [
            {
                id: 1,
                title: 'Frustrated',
                slug: 'customer_tone_frustrated',
            },
            {
                id: 2,
                title: 'Impolite',
                slug: 'customer_tone_impolite',
            },
            {
                id: 3,
                title: 'Sad',
                slug: 'customer_tone_sad',
            }
        ]
    },
    {
        id: 5,
        title: 'Agent Tonality',
        slug: 'agent_tonality',
        parameters: [
            {
                id: 1,
                title: 'Frustrated',
                slug: 'agent_tone_frustrated',
            },
            {
                id: 2,
                title: 'Impolite',
                slug: 'agent_tone_impolite',
            }
        ]
    },
]


// Facets Distribution list
export const facets: Array<{}> = [
    {
        title: 'Conversation Type',
        bucketTitle: 'Conversation Type',
        slug: 'communication_mode',
    },
    {
        title: 'Duration > AHT',
        bucketTitle: 'Flags',
        slug: 'duration_gt_aht',
    },
    {
        title: 'Hold Time / Wait Time',
        bucketTitle: 'Flags',
        slug: 'hold_or_wait_time',
    },
    {
        title: 'Agent Fast Paced',
        bucketTitle: 'Flags',
        slug: 'agent_fast_paced',
    },
    {
        title: 'Customer Escalation',
        bucketTitle: 'Flags',
        slug: 'customer_escalation',
    },
    {
        title: 'Agent Skipped Intro',
        bucketTitle: 'Flags',
        slug: 'agent_skipped_intro',
    },
    {
        title: 'Agent Skipped Salutation',
        bucketTitle: 'Flags',
        slug: 'agent_skipped_salutation',
    },
    {
        title: 'Frustrated',
        bucketTitle: 'Customer Tonality',
        slug: 'customer_tone_frustrated',
    },
    {
        title: 'Impolite',
        bucketTitle: 'Customer Tonality',
        slug: 'customer_tone_impolite',
    },
    {
        title: 'Sad',
        bucketTitle: 'Customer Tonality',
        slug: 'customer_tone_sad',
    },
    {
        title: 'Frustrated',
        bucketTitle: 'Agent Tonality',
        slug: 'agent_tone_frustrated',
    },
    {
        title: 'Impolite',
        bucketTitle: 'Agent Tonality',
        slug: 'agent_tone_impolite',
    },
    {
        title: 'Customer Profanity',
        bucketTitle: 'Flags',
        slug: 'customer_profanity',
    },
    {
        title: 'Agent Profanity',
        bucketTitle: 'Flags',
        slug: 'agent_profanity',
    },
    {
        title: 'Customer Declining Sentiment',
        bucketTitle: 'Flags',
        slug: "customer_declining_sentiment"
    },
    {
        title: 'Agent Declining Sentiment',
        bucketTitle: 'Flags',
        slug: 'agent_declining_sentiment',
    },
    {
        title: 'CX Topics',
        bucketTitle: 'CX Topics',
        slug: cxTopicSignal
    },
]